import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Modal, Box} from '@material-ui/core';
import styles from './LineTransferModal.module.css';

const LineTransferModal = ({
  title,
  open,
  handleClose,
  rowsData,
  handleSubmit,
  lineBackgroundColor,
  lines,
  cancelButtonText = 'Cancel',
  submitButtonText = 'Confirm',
}) => {
  const defaultLine = 'Select a Line';
  const [selectedLineForTransfer, setSelectedLineForTransfer] = useState('');
  const [error, setError] = useState(null);

  const Select = ({label, id, options, defaultOption, ...selectProps}) => {
    return (
      <div className={styles.defineRow}>
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
        <select
          id={id}
          className={clsx(styles.popupSelect, styles.vl3)}
          {...selectProps}
        >
          <option value={''} key={'default'}>
            {defaultOption}
          </option>
          {options.map(option => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleSelectChangeCurry = setState => e => setState(e.target.value);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <div>
              <span>{title}</span>
            </div>
            <div
              className={styles.formlLineDiv}
              style={{
                backgroundColor: lineBackgroundColor,
              }}
            />
          </div>
          <div className={styles.subHeading}>Note: *Mandatory fields</div>
          <Box bgcolor="#dadada3d" paddingTop="1px" paddingBottom="1px">
            <Select
              defaultOption={defaultLine}
              id="select-line"
              name="Line"
              label="Line *"
              options={lines}
              value={selectedLineForTransfer}
              onChange={handleSelectChangeCurry(setSelectedLineForTransfer)}
            />
            <div className={styles.errorText}>
              <em>{error}</em>
            </div>
          </Box>
          <div className={styles.bottomRow}>
            <button className={styles.cancelBt} onClick={handleClose}>
              {cancelButtonText}
            </button>
            <span>
              <button
                onClick={() => {
                  if (selectedLineForTransfer ) {
                    handleSubmit(selectedLineForTransfer);
                    handleClose();
                  } else {
                    setError('*Please Select a Line');
                  }
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

LineTransferModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      vc: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      fbv: PropTypes.string.isRequired,
    }),
  ),
  lines: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  lineBackgroundColor: PropTypes.string,
};

export default LineTransferModal;
